<template>
  <div></div>
</template>
    
<script>
export default {
  name: "UpdateAddressView",
  components: {},
};
</script>